











import { notify } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { HasTaskMixin } from '@/mixins';
import { refresh } from '@/email-campaign/email-campaign';
import { DetailedEmailCampaign } from '@/types';

export default HasTaskMixin.extend({
  props: {
    emailCampaignId: {
      type: String,
      required: true,
    },
  },
  methods: {
    refresh(): void {
      this.task = refresh(this.emailCampaignId);
      this.task.then((emailCampaign: DetailedEmailCampaign) => {
        this.$emit('refreshed', emailCampaign);
        notify.success(`${emailCampaign.name} data synced.`);
      });
    },
    isGranted,
  },
});
